/**
 * The ibanToggle filter yields to ease the visualization
 * of an splitted iban by displaying the contained
 * bank code and account number.
 */
export const ibanToggleFilter = () => {
  'ngInject';
  return (input) => {
    if (angular.isObject(input) && input.account) {
      const { bankIdentifier, accountNumber } = input.account;
      return [bankIdentifier, accountNumber].join(' ');
    }
    return input;
  };
};
